/**
 * Analytics for preview component. What do we have here:
 *   - Listener for file_id route parameter. Everytime the URL for preview changes, send an event.
 */
import Analytics from '@module/analytics';

const fileIdFilter = (state = {}) =>
  state && state.route && state.route.params && state.route.params.file_id;
const fileIdOnChange = (value, previousValue, { route, transfer }) => {
  if (!route.params.file_id) {
    // This is the case when we close the preview panel
    return;
  }

  const fileId = route.params.file_id;
  const items = transfer.items || [];
  const item = items.find((item) => item.id === fileId) || {};
  const payload = {
    category: 'preview page',
    action: 'preview',
    label: `Item ${item.id}`,
    item: {
      id: fileId,
      previewable: item.previewable,
    },
  };

  Analytics.pushDataLayerEvent(payload);
};

export const actions = {};

export const states = {
  fileId: [fileIdFilter, fileIdOnChange],
};

export const methods = {};
